import React, { createRef, RefObject, useState } from 'react'
import { Box, IconButton, styled, Typography } from '@mui/material'
import { HelpFill } from '@zuto/icons'
import { CloseToolTip } from '../../../icons'

interface HintProps extends React.HTMLAttributes<HTMLDivElement> {
    showHintByDefault: boolean
    onClick?: () => void
}

export interface HintTextProps extends React.HTMLAttributes<HTMLDivElement> {
    show: boolean
}

const StyledBox = styled(Box)(({ theme }) => ({
    color: theme.customPalette.secondary[60],
    '&:hover, &:active, &:focus': {
        color: theme.customPalette.secondary[50]
    }
}))

const MuiHint = ({ children, onClick, showHintByDefault, ...props }: HintProps): JSX.Element => {
    const [visible, setVisible] = useState(showHintByDefault)
    const hintText: RefObject<HTMLDivElement> = createRef()

    const toggleVisibility = () => {
        if (onClick) {
            onClick()
        }
        setVisible(prev => !prev)
        if (hintText.current?.style) {
            hintText.current.style.removeProperty('padding')
            hintText.current.style.removeProperty('margin')
        }
    }

    const transitionEnd = () => {
        if (!visible && hintText.current) {
            hintText.current.style.padding = '0'
            hintText.current.style.margin = '0'
        }
    }

    return (
        <>
            <IconButton
                aria-label="show hint message"
                data-testid="hint-button"
                onClick={toggleVisibility}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    alignSelf: 'flex-end',
                    padding: 0,
                    height: 26,
                    width: 26,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer'
                }}
            >
                <StyledBox>
                    {visible ? <CloseToolTip /> : <HelpFill />}
                </StyledBox>
            </IconButton>
            <Box
                {...props}
                ref={hintText}
                data-testid="hint-message"
                onTransitionEnd={transitionEnd}
                sx={{
                    transition: 'opacity .3s ease, max-height .3s ease-out, padding .3s ease, margin .2s ease',
                    opacity: visible ? 1 : 0,
                    maxHeight: visible ? '15em' : 0,
                    overflow: visible ? 'visible' : 'hidden',
                    boxSizing: 'border-box',
                    position: 'relative',
                    // backgroundColor: '#E5F8F5',
                    // border: '1px solid #0FB799',
                    backgroundColor: theme => theme.customPalette.tertiary[95],
                    borderRadius: 2,
                    padding: visible ? 4 : 0,
                    my: visible ? 5 : 0
                }}
            >
                {/* <Box
                    component={HintPointer}
                    sx={{
                        transition: 'opacity .3s ease',
                        opacity: visible ? 1 : 0,
                        position: 'absolute',
                        right: '-1px',
                        top: '-19px',
                        pointerEvents: 'none'
                    }}
                /> */}
                <Typography variant="bodyLarge">{children}</Typography>
            </Box>
        </>
    )
}

export default MuiHint